import { useContext } from "react";
import { type RouteMetadata, RouteMetadataContext } from "src/contexts/RouteMetadataContext";

/**
 * Hook to access route metadata (like page name) in components
 *
 * @example
 * const { page } = useRouteMetadata();
 */
export function useRouteMetadata(): RouteMetadata & {
    setMetadata: (metadata: RouteMetadata) => void;
    updateMetadata: (metadata: Partial<RouteMetadata>) => void;
} {
    const { metadata, setMetadata, updateMetadata } = useContext(RouteMetadataContext);
    return {
        ...metadata,
        setMetadata,
        updateMetadata,
    };
}
